var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInvisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-off-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.76722 4.94544L1.16155 2.33977L2.34006 1.16125L18.8392 17.6604L17.6607 18.839L14.9024 16.0806C13.4847 16.9795 11.8033 17.5001 10.0004 17.5001C5.50693 17.5001 1.76862 14.267 0.984863 10.0001C1.34876 8.01898 2.3496 6.26071 3.76722 4.94544ZM12.2982 13.4765L11.0782 12.2565C10.7518 12.4126 10.3863 12.5001 10.0004 12.5001C8.61966 12.5001 7.50038 11.3808 7.50038 10.0001C7.50038 9.61413 7.58785 9.24863 7.74402 8.92221L6.52405 7.70227C6.08778 8.36096 5.83371 9.15088 5.83371 10.0001C5.83371 12.3013 7.6992 14.1668 10.0004 14.1668C10.8496 14.1668 11.6395 13.9127 12.2982 13.4765ZM6.64555 3.13342C7.68455 2.72462 8.81625 2.5001 10.0004 2.5001C14.4938 2.5001 18.2322 5.73323 19.0159 10.0001C18.7557 11.4165 18.17 12.719 17.3392 13.827L14.1227 10.6105C14.1519 10.4113 14.1671 10.2075 14.1671 10.0001C14.1671 7.6989 12.3016 5.83343 10.0004 5.83343C9.793 5.83343 9.58916 5.84857 9.38991 5.87782L6.64555 3.13342Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvisible);
export default __webpack_public_path__ + "static/media/icon_invisible.16f35a397f790bfea1a6c2fcff6e129f.svg";
export { ForwardRef as ReactComponent };